<template>
  <div v-if="show" class="sm-overlay">
    <div class="sm-box">
      <div class="sm-icon">
        <fa-icon :icon="['fas', 'clock']" />
      </div>
      <h5 class="sm-title">Session Expired</h5>
      <p class="sm-msg">
        <slot>Your session has expired. Continue to refresh, or sign out.</slot>
      </p>
      <div class="sm-actions">
        <button class="sm-btn sm-btn-ghost" @click="$emit('signout')">Sign Out</button>
        <button class="sm-btn sm-btn-primary" @click="$emit('continue')">Continue Session</button>
      </div>
    </div>
  </div>
</template>

<script>
import bodyScrollLockMixin from '@/mixins/bodyScrollLockMixin'

export default {
  name: 'SessionModal',
  mixins: [bodyScrollLockMixin],
  props: {
    show: { type: Boolean, default: false }
  }
}
</script>
